// extracted by mini-css-extract-plugin
module.exports = {"container":"Signature_container__3hLEw","signature":"Signature_signature__2VymH","date":"Signature_date__QogUO","title":"Signature_title__2A6Dj","doctor":"Signature_doctor__1sAP8"};